var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIr(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 54,
    height: 40,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.4v40H.3z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-8 0h70v40H-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#da0000",
    d: "M-8 26.9h70V40H-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.3 27.4h3.8v.3H5.3zm.6 1.3v.3zm3.3 0v.3h-.8v-.3zm.4-1.3h.2V29h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11 28.7v.3H9.7v-.3zm-2.6-.6h.2v.9h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.9 27.4h.2V29H11zm-.7 0h.3V29h-.3zm-3.5.6v.3H5.3V28zm3 0v.3H8.5V28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.4 28.1h.2v.9h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.4 28.1h.2v.9h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.4 28.1h.2v.9h-.2zm-3 0h.2v.9h-.3zm2.2 0h.2v.9h-.2zm-1.1 0h.2v.9h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.8 28.7v.3H6.6v-.3zm0-.7v.3h-.7V28zm-8.8-.6h3.8v.3H-1zm.6 1.3h.3v.3h-.3zm3.3 0v.3H2v-.3zm.4-1.3h.2V29h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.8 28.7v.3H3.3v-.3zm-2.7-.6h.3v.9H2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.6 27.4h.2V29h-.2zm-.7 0h.3V29h-.3zM.4 28v.3H-1V28zm3 0v.3H2.2V28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2 28.1h.4v.9H2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2 28.1h.4v.9H2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2 28.1h.4v.9H2zm-3 0h.3v.9H-1zm2.3 0h.2v.9h-.2zm-1.1 0h.2v.9H.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.5 28.7v.3H.3v-.3zm0-.7v.3H.8V28zm10.1-.6h3.8v.3h-3.8zm.5 1.3h.3v.3H12zm3.3 0v.3h-.8v-.3zm.4-1.3h.3V29h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.3 28.7v.3H16v-.3zm-2.7-.6h.3v.9h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.1 27.4h.3V29H17zm-.6 0h.2V29h-.2zM13 28v.3h-1.4V28zm3 0v.3h-1.4V28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.6 28.1h.3v.9h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.6 28.1h.3v.9h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.6 28.1h.3v.9h-.3zm-3 0h.2v.9h-.2zm2.2 0h.3v.9h-.3zm-1.1 0h.3v.9h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14 28.7v.3h-1.2v-.3zm0-.7v.3h-.7V28zm3.8-.6h3.9v.3h-3.9zm.6 1.3h.3v.3h-.3zm3.3 0v.3h-.8v-.3zm.4-1.3h.3V29H22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.6 28.7v.3h-1.4v-.3zm-2.7-.6h.3v.9h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.4 27.4h.3V29h-.3zm-.7 0h.3V29h-.3zm-3.5.6v.3h-1.4V28zm3.1 0v.3H21V28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21 28.1h.2v.9h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21 28.1h.2v.9h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21 28.1h.2v.9h-.3zm-3.2 0h.3v.9h-.3zm2.3 0h.3v.9H20zm-1.1 0h.2v.9H19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.3 28.7v.3H19v-.3zm0-.7v.3h-.7V28zm3.8-.6H28v.3h-4zm.6 1.3h.3v.3h-.3zm3.3 0v.3h-.8v-.3zm.4-1.3h.3V29h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30 28.7v.3h-1.5v-.3zm-2.8-.6h.3v.9h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.7 27.4h.3V29h-.3zm-.6 0h.2V29h-.2zm-3.5.6v.3H24V28zm3 0v.3h-1.4V28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.2 28.1h.3v.9h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.2 28.1h.3v.9h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.2 28.1h.3v.9h-.3zm-3 0h.2v.9h-.2zm2.2 0h.3v.9h-.3zm-1.1 0h.3v.9h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.6 28.7v.3h-1.2v-.3zm0-.7v.3H26V28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#239f40",
    d: "M-8 0h70v13.1H-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30.5 27.4h3.8v.3h-3.8zm.6 1.3h.2v.3h-.2zm3.2 0v.3h-.7v-.3zm.5-1.3h.2V29h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.3 28.7v.3h-1.5v-.3zm-2.7-.6h.2v.9h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36 27.4h.3V29h-.2zm-.6 0h.3V29h-.3zm-3.5.6v.3h-1.4V28zm3 0v.3h-1.3V28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.6 28.1h.2v.9h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.6 28.1h.2v.9h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.6 28.1h.2v.9h-.2zm-3.1 0h.3v.9h-.3zm2.3 0h.2v.9h-.2zm-1.2 0h.3v.9h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33 28.7v.3h-1.2v-.3zm0-.7v.3h-.7V28zm3.8-.6h3.8v.3h-3.8zm.6 1.3h.2v.3h-.2zm3.2 0v.3H40v-.3zm.5-1.3h.2V29h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M42.6 28.7v.3H41v-.3zm-2.7-.6h.2v.9H40z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M42.4 27.4h.2V29h-.2zm-.7 0h.3V29h-.3zm-3.5.6v.3h-1.4V28zm3 0v.3H40V28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39.9 28.1h.2v.9H40z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39.9 28.1h.2v.9H40z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39.9 28.1h.2v.9H40zm-3.1 0h.3v.9h-.3zm2.3 0h.2v.9h-.2zm-1.2 0h.3v.9h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39.2 28.7v.3h-1.1v-.3zm.1-.7v.3h-.7V28zm3.8-.6H47v.3h-3.8zm.6 1.3h.2v.3h-.2zm3.3 0v.3h-.8v-.3zm.4-1.3h.2V29h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.9 28.7v.3h-1.5v-.3zm-2.7-.6h.2v.9h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.7 27.4h.2V29h-.2zm-.7 0h.3V29H48zm-3.5.6v.3h-1.4V28zm3 0v.3h-1.3V28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.2 28.1h.2v.9h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.2 28.1h.2v.9h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.2 28.1h.2v.9h-.2zm-3 0h.2v.9H43zm2.2 0h.2v.9h-.2zm-1.1 0h.2v.9h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.5 28.7v.3h-1.1v-.3zm.1-.7v.3H45V28zm3.9-.6h3.8v.3h-3.8zm.5 1.3h.3v.3H50zm3.3 0v.3h-.8v-.3zm.4-1.3h.3V29h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55.2 28.7v.3h-1.4v-.3zm-2.7-.6h.3v.9h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55 27.4h.3V29H55zm-.6 0h.2V29h-.2zm-3.5.6v.3h-1.4V28zm3 0v.3h-1.4V28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M52.5 28.1h.3v.9h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M52.5 28.1h.3v.9h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M52.5 28.1h.3v.9h-.3zm-3 0h.2v.9h-.2zm2.2 0h.3v.9h-.3zm-1.1 0h.3v.9h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.9 28.7v.3h-1.2v-.3zm0-.7v.3h-.7V28zM5.3 11.2h3.8v.3H5.3zm.6 1.3v.3zm3.3 0v.3h-.8v-.3zm.4-1.3h.2v1.6h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11 12.5v.3H9.7v-.3zM8.5 12h.2v.9h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.9 11.2h.2v1.6H11zm-.7 0h.3v1.6h-.3zm-3.5.6v.3H5.3v-.3zm3 0v.3H8.5v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.4 11.9h.2v.9h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.4 11.9h.2v.9h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.4 11.9h.2v.9h-.2zm-3 0h.2v.9h-.3zm2.2 0h.2v.9h-.2zm-1.1 0h.2v.9h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.8 12.5v.3H6.6v-.3zm0-.7v.3h-.7v-.3zm-8.8-.6h3.8v.3H-1zm.6 1.3h.3v.3h-.3zm3.3 0v.3H2v-.3zm.4-1.3h.2v1.6h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.8 12.5v.3H3.3v-.3zM2.1 12h.3v.9H2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.6 11.2h.2v1.6h-.2zm-.7 0h.3v1.6h-.3zm-3.5.6v.3H-1v-.3zm3 0v.3H2.2v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2 11.9h.4v.9H2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2 11.9h.4v.9H2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2 11.9h.4v.9H2zm-3 0h.3v.9H-1zm2.3 0h.2v.9h-.2zm-1.1 0h.2v.9H.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.5 12.5v.3H.3v-.3zm0-.7v.3H.8v-.3zm10.1-.6h3.8v.3h-3.8zm.5 1.3h.3v.3H12zm3.3 0v.3h-.8v-.3zm.4-1.3h.3v1.6h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.3 12.5v.3H16v-.3zm-2.7-.6h.3v.9h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.1 11.2h.3v1.6H17zm-.6 0h.2v1.6h-.2zm-3.5.6v.3h-1.4v-.3zm3 0v.3h-1.4v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.6 11.9h.3v.9h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.6 11.9h.3v.9h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.6 11.9h.3v.9h-.3zm-3 0h.2v.9h-.2zm2.2 0h.3v.9h-.3zm-1.1 0h.3v.9h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14 12.5v.3h-1.2v-.3zm0-.7v.3h-.7v-.3zm3.8-.6h3.9v.3h-3.9zm.6 1.3h.3v.3h-.3zm3.3 0v.3h-.8v-.3zm.4-1.3h.3v1.6H22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.6 12.5v.3h-1.4v-.3zM21 12h.3v.9H21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.4 11.2h.3v1.6h-.3zm-.7 0h.3v1.6h-.3zm-3.5.6v.3h-1.4v-.3zm3.1 0v.3H21v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21 11.9h.2v.9h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21 11.9h.2v.9h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21 11.9h.2v.9h-.3zm-3.2 0h.3v.9h-.3zm2.3 0h.3v.9H20zm-1.1 0h.2v.9H19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.3 12.5v.3H19v-.3zm0-.7v.3h-.7v-.3zm3.8-.6H28v.3h-4zm.6 1.3h.3v.3h-.3zm3.3 0v.3h-.8v-.3zm.4-1.3h.3v1.6h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30 12.5v.3h-1.5v-.3zm-2.8-.6h.3v.9h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.7 11.2h.3v1.6h-.3zm-.6 0h.2v1.6h-.2zm-3.5.6v.3H24v-.3zm3 0v.3h-1.4v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.2 11.9h.3v.9h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.2 11.9h.3v.9h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.2 11.9h.3v.9h-.3zm-3 0h.2v.9h-.2zm2.2 0h.3v.9h-.3zm-1.1 0h.3v.9h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.6 12.5v.3h-1.2v-.3zm0-.7v.3H26v-.3zm3.9-.6h3.8v.3h-3.8zm.6 1.3h.2v.3h-.2zm3.2 0v.3h-.7v-.3zm.5-1.3h.2v1.6h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.3 12.5v.3h-1.5v-.3zm-2.7-.6h.2v.9h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36 11.2h.3v1.6h-.2zm-.6 0h.3v1.6h-.3zm-3.5.6v.3h-1.4v-.3zm3 0v.3h-1.3v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.6 11.9h.2v.9h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.6 11.9h.2v.9h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.6 11.9h.2v.9h-.2zm-3.1 0h.3v.9h-.3zm2.3 0h.2v.9h-.2zm-1.2 0h.3v.9h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33 12.5v.3h-1.2v-.3zm0-.7v.3h-.7v-.3zm3.8-.6h3.8v.3h-3.8zm.6 1.3h.2v.3h-.2zm3.2 0v.3H40v-.3zm.5-1.3h.2v1.6h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M42.6 12.5v.3H41v-.3zm-2.7-.6h.2v.9H40z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M42.4 11.2h.2v1.6h-.2zm-.7 0h.3v1.6h-.3zm-3.5.6v.3h-1.4v-.3zm3 0v.3H40v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39.9 11.9h.2v.9H40z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39.9 11.9h.2v.9H40z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39.9 11.9h.2v.9H40zm-3.1 0h.3v.9h-.3zm2.3 0h.2v.9h-.2zm-1.2 0h.3v.9h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39.2 12.5v.3h-1.1v-.3zm.1-.7v.3h-.7v-.3zm3.8-.6H47v.3h-3.8zm.6 1.3h.2v.3h-.2zm3.3 0v.3h-.8v-.3zm.4-1.3h.2v1.6h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.9 12.5v.3h-1.5v-.3zm-2.7-.6h.2v.9h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.7 11.2h.2v1.6h-.2zm-.7 0h.3v1.6H48zm-3.5.6v.3h-1.4v-.3zm3 0v.3h-1.3v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.2 11.9h.2v.9h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.2 11.9h.2v.9h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.2 11.9h.2v.9h-.2zm-3 0h.2v.9H43zm2.2 0h.2v.9h-.2zm-1.1 0h.2v.9h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.5 12.5v.3h-1.1v-.3zm.1-.7v.3H45v-.3zm3.9-.6h3.8v.3h-3.8zm.5 1.3h.3v.3H50zm3.3 0v.3h-.8v-.3zm.4-1.3h.3v1.6h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55.2 12.5v.3h-1.4v-.3zm-2.7-.6h.3v.9h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55 11.2h.3v1.6H55zm-.6 0h.2v1.6h-.2zm-3.5.6v.3h-1.4v-.3zm3 0v.3h-1.4v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M52.5 11.9h.3v.9h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M52.5 11.9h.3v.9h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M52.5 11.9h.3v.9h-.3zm-3 0h.2v.9h-.2zm2.2 0h.3v.9h-.3zm-1.1 0h.3v.9h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.9 12.5v.3h-1.2v-.3zm0-.7v.3h-.7v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d90000",
    d: "M1.6 26.5h.5v.8h-.5zm12.6 0h.4v.8h-.4zm-22.2 0h.5v.8H-8zm6.4 0h.4v.8h-.4zm6.3 0h.5v.8h-.5zm3.1 0h.5v.8h-.5zm3.2 0h.5v.8H11zm6.3 0h.5v.8h-.5zm15.8 0h.5v.8h-.4zm-12.6 0h.5v.8h-.5zm3.1 0h.5v.8h-.5zm3.2 0h.4v.8h-.4zm3.1 0h.5v.8h-.5zm25.3 0h.4v.8h-.4zm-19 0h.5v.8h-.5zm3.2 0h.5v.8h-.5zm3.2 0h.5v.8h-.5zm3 0h.5v.8h-.4zm3.3 0h.5v.8h-.5zm3.1 0h.5v.8H52zm9.4 0h.5v.8h-.5zm-3 0h.4v.8h-.4zm-63.2 0h.4v.8h-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#239e3f",
    d: "M1.6 12.7h.5v.8h-.5zm12.6 0h.4v.8h-.4zm-22.2 0h.5v.8H-8zm6.4 0h.4v.8h-.4zm6.3 0h.5v.8h-.5zm3.1 0h.5v.8h-.5zm3.2 0h.5v.8H11zm6.3 0h.5v.8h-.5zm15.8 0h.5v.8h-.4zm-12.6 0h.5v.8h-.5zm3.1 0h.5v.8h-.5zm3.2 0h.4v.8h-.4zm3.1 0h.5v.8h-.5zm25.3 0h.4v.8h-.4zm-19 0h.5v.8h-.5zm3.2 0h.5v.8h-.5zm3.2 0h.5v.8h-.5zm3 0h.5v.8h-.4zm3.3 0h.5v.8h-.5zm3.1 0h.5v.8H52zm9.4 0h.5v.8h-.5zm-3 0h.4v.8h-.4zm-63.2 0h.4v.8h-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#da0000",
    d: "M28.9 15.4c.6.8 2.7 5.3-1.3 8.2-1.8 1.4-.7 1.5-.6 1.7 3-1.5 4-3.7 3.9-5.6 0-1.9-1-3.6-2-4.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#da0000",
    d: "M29.3 15.2a5.7 5.7 0 0 1 1.2 8.8c2.1-.5 4.8-6.7-1.2-8.8m-4.6 0a5.7 5.7 0 0 0-1.2 8.8c-2.1-.5-4.8-6.7 1.3-8.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#da0000",
    d: "M25.1 15.4c-.6.8-2.7 5.3 1.3 8.2 1.8 1.4.7 1.5.6 1.7-3-1.5-4-3.7-3.9-5.6 0-1.9 1-3.6 2-4.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#da0000",
    d: "M30.8 25c-1.2 0-2.7-.2-3.7-.8l.5 1c1 0 2.4.1 3.2-.3m-7.5 0q2 0 3.8-.8l-.6 1c-1 0-2.4.1-3.2-.3m2.2-11q.4 1 1.5.4.9.5 1.5-.3c.2 1.6-1.5 1.2-1.5.9-.6.6-1.7.3-1.5-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#da0000",
    d: "m27 26 .6-.8.1-9.4-.7-.6-.7.6.1 9.4z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIr);
export default __webpack_public_path__ + "static/media/ir.b530c617187761e0f6213810e583af09.svg";
export { ForwardRef as ReactComponent };